import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Field } from "./Tenant/Applications/Airsweb/Models";

@Pipe({
    name: 'fieldGroupFilter',
    pure: false
})
@Injectable({
    providedIn: 'root'
})
export class FieldGroupFilter implements PipeTransform {

    transform(items: Field[], args: string[]): any {
		let regex = new RegExp(`(${args[1]})`, "i");

		var filteredItems = items.filter(f => {
			return f.UiGroupName === args[0] && (!args[1] || regex.test(f.FieldName))
		});

	    var maxOrder = Math.max.apply(Math,
		    filteredItems.map(o => o.Order));

	    filteredItems.forEach(x => {
		    if (!x.Order) {
			    x.Order = ++maxOrder;
		    }
	    });

	    filteredItems.sort((a: Field, b: Field) => {
		    if (a.Order < b.Order) return -1;
		    if (a.Order > b.Order) return 1;
		    return 0;
		});

	    return filteredItems;
    }
}
